import { render, staticRenderFns } from "./usermanage.vue?vue&type=template&id=1318cdec"
import script from "./usermanage.vue?vue&type=script&lang=js"
export * from "./usermanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports